/* eslint-disable */
import { Model } from '@vuex-orm/core'

class CTTShopType extends Model {
  static fields() {
    return {
      id: this.string(),
      name: this.string(),
      slug: this.string(),
      createdAt: this.attr(),
      updatedAt: this.attr(),
    }
  }

  static list(options = {}) {
    return this.api().request({
      method: 'GET',
      url: `/chang-tt/shop-types`,
      ...options,
    }).then((res) => res.response.data)
  }
}

CTTShopType.entity = 'shoptype'

export default CTTShopType